'use client';

import { useEffect, useLayoutEffect } from 'react';

import { isSSR } from './isSSR';

export const useIsomorphicLayoutEffect = isSSR ? useEffect : useLayoutEffect;
